import React from "react";
import ContractDashboard, { fromWei } from "./shared/ContractDashboard";
import lpRewardFunctions from "./functions/lpRewardFunctions";
import { nemiLpReward, nemiLpRewardAbi } from "./Contract";

const short = (v) => `${String(v).slice(0, 8)}…${String(v).slice(-6)}`;

/**
 * Nemi LP Reward — collects protocol fees, swaps them into NEMI and tops up liquidity.
 * Every function of the nemiLpReward contract is available through the tabs below.
 */
export default function LpRewardPage() {
  const overview = [
    {
      key: "globalMarketPlaceReward",
      label: "Marketplace Reward Pool",
      icon: "🛒",
      method: "globalMarketPlaceReward",
      format: (v) => `${fromWei(v)} USDT`,
      color: "#00ff88",
    },
    {
      key: "globalMatrixReward",
      label: "Matrix Reward Pool",
      icon: "🧬",
      method: "globalMatrixReward",
      format: (v) => `${fromWei(v)} USDT`,
      color: "#45b7d1",
    },
    {
      key: "swapCount",
      label: "Swaps Executed",
      icon: "🔁",
      method: "swapCount",
      color: "#00ccff",
    },
    {
      key: "swapThreshold",
      label: "Swap Threshold",
      icon: "⚖️",
      method: "swapThreshold",
      format: (v) => `every ${v}`,
      color: "#ffaa00",
    },
    {
      key: "liquidityFundCount",
      label: "Liquidity Top-ups",
      icon: "💧",
      method: "liquidityFundCount",
      color: "#6be0d7",
    },
    {
      key: "liquidityFundThreshold",
      label: "Liquidity Threshold",
      icon: "📏",
      method: "liquidityFundThreshold",
      format: (v) => `every ${v} swaps`,
      color: "#ff00aa",
    },
    {
      key: "contractUsdt",
      label: "Contract USDT",
      icon: "🏦",
      color: "#26a17b",
      format: (v) => `${v} USDT`,
      compute: async ({ getTokenContract, address }) =>
        fromWei(await getTokenContract("USDT").methods.balanceOf(address).call()),
    },
    {
      key: "contractNemi",
      label: "Contract NEMI",
      icon: "🪙",
      color: "#00ccff",
      format: (v) => `${v} NEMI`,
      compute: async ({ getTokenContract, address }) =>
        fromWei(await getTokenContract("NEMI").methods.balanceOf(address).call()),
    },
    {
      key: "lpReceiver",
      label: "LP Receiver",
      icon: "📥",
      method: "lpReceiver",
      format: short,
      color: "#ffaa00",
    },
    {
      key: "pair",
      label: "Pancake Pair",
      icon: "🥞",
      method: "pair",
      format: short,
      color: "#ff8800",
    },
    {
      key: "router",
      label: "Router",
      icon: "🛣️",
      method: "router",
      format: short,
      color: "#45b7d1",
    },
    {
      key: "paused",
      label: "Contract Status",
      icon: "⚡",
      method: "paused",
      format: (v) => (v === true || v === "true" ? "PAUSED" : "ACTIVE"),
      color: "#ff6b6b",
    },
  ];

  return (
    <ContractDashboard
      title="Nemi LP Reward"
      subtitle="Collects protocol fees, swaps them into NEMI and tops up the liquidity pool"
      icon="💧"
      accent="#00ccff"
      address={nemiLpReward}
      abi={nemiLpRewardAbi}
      functions={lpRewardFunctions}
      overview={overview}
      approvalTokens={["USDT", "NEMI"]}
    />
  );
}
